import { statusHandeling } from "../../statusHandeling";
import config from "./../../config";

function authHeader() {
  let user = JSON.parse(localStorage.getItem("user"));
  if (user) {
    if (user.key) {
      return { Authorization: "Token  " + user.key };
    } else {
      return {};
    }
  } else {
    return {};
  }
}


/////////////// GETS ///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

const getAllBoards = async (page, type) => {
  const myHeaders = Object.assign({ "Content-Type": "application/json" }, authHeader());

  const req = new Request(
    `${config.apiGateway.URL}/clinics/staging-groups/?page=${page}&type=${type}&office_id=${localStorage.getItem("selectedOffice")}`,
    {
      method: "GET",
      headers: myHeaders,
    }
  );
  const response = await fetch(req);
  const json = await response.json();
  const res = {
    json: json,
    status: response.status,
    message: response.message,
  };

  return res;
};

const manualBoardSearchPatient = async (boardID, queryParams) => {
  const myHeaders = Object.assign({ "Content-Type": "application/json" }, authHeader());

  const req = new Request(
    `${config.apiGateway.URL}/clinics/staging-groups/${boardID}/manual-group-patients-search/?${queryParams}&office_id=${localStorage.getItem(
      "selectedOffice"
    )}`,
    {
      method: "GET",
      headers: myHeaders,
    }
  );
  const response = await fetch(req);
  const json = await response.json();
  const res = {
    json: json,
    status: response.status,
    message: response.message,
  };

  return res;
};

const autoBoardSearchPatient = async (boardID, queryParams) => {
  const myHeaders = Object.assign({ "Content-Type": "application/json" }, authHeader());

  const req = new Request(`${config.apiGateway.URL}/clinics/staging-groups/${boardID}/get-auto-group-patients/?${queryParams}`, {
    method: "GET",
    headers: myHeaders,
  });
  const response = await fetch(req);
  const json = await response.json();
  const res = {
    json: json,
    status: response.status,
    message: response.message,
  };

  return res;
};

const getProcessingPatients = async (boardID) => {
  const myHeaders = Object.assign({ "Content-Type": "application/json" }, authHeader());

  const req = new Request(`${config.apiGateway.URL}/clinics/staging-groups/${boardID}/get-auto-group-patients/`, {
    method: "GET",
    headers: myHeaders,
  });
  const response = await fetch(req);
  const json = await response.json();
  const res = {
    json: json,
    status: response.status,
    message: response.message,
  };

  return res;
};

const getPatientsByOffice = async (boardID, page, queryParams) => {
  const myHeaders = Object.assign({ "Content-Type": "application/json" }, authHeader());

  const req = new Request(
    `${config.apiGateway.URL}/clinics/patient-list/?page=${page}&page_size=10&staging_group_id=${boardID}&office_id=${localStorage.getItem(
      "selectedOffice"
    )}&${queryParams}`,
    {
      method: "GET",
      headers: myHeaders,
    }
  );
  const response = await fetch(req);
  const json = await response.json();
  const res = {
    json: json,
    status: response.status,
    message: response.message,
  };

  return res;
};

const getPatientDetails = async (patientId) => {
  const myHeaders = Object.assign({ "Content-Type": "application/json" }, authHeader());

  const req = new Request(`${config.apiGateway.URL}/clinics/staging-groups/patient-details/${patientId}/`, {
    method: "GET",
    headers: myHeaders,
  });

  const response = await fetch(req);
  const json = await response.json();
  const res = {
    json: json,
    status: response.status,
    message: response.message,
  };

  return res;
};

const getBoardDetails = async (boardId) => {
  const myHeaders = Object.assign({ "Content-Type": "application/json" }, authHeader());

  const req = new Request(
    `${config.apiGateway.URL}/clinics/retrieve-staging-group/${boardId}/`,
    {
      method: "GET",
      headers: myHeaders,
    }
  );

  const response = await fetch(req);
  const json = await response.json();
  const res = {
    json: json,
    status: response.status,
    message: response.message,
  };

  return res;
};

// audienceType = 'include' or 'exclude'
const getAudienceSelectorsByOfficeId = async (audienceType) => {
  const myHeaders = Object.assign({ "Content-Type": "application/json" }, authHeader());

  const req = new Request(
    `${config.apiGateway.URL}/clinics/audience-selectors-list/${localStorage.getItem("selectedOffice")}/?method_type=${audienceType}`,
    {
      method: "GET",
      headers: myHeaders,
    }
  );
  const response = await fetch(req);
  const json = await response.json();
  const res = {
    json: json,
    status: response.status,
    message: response.message,
  };

  return res;
};

const getEmailTemplates = async (isSms) => {
  const myHeaders = Object.assign({ "Content-Type": "application/json" }, authHeader());

  const req = new Request(
    `${config.apiGateway.URL}/clinics/campaign-${isSms ? 'sms' : 'email'}-templates/`,
    {
      method: "GET",
      headers: myHeaders,
    }
  );
  const response = await fetch(req);
  const json = await response.json();
  const res = {
    json: json,
    status: response.status,
    message: response.message,
  };

  return res;
};


const getActionTriggerOptions = async () => {
  const myHeaders = Object.assign({ "Content-Type": "application/json" }, authHeader());

  const req = new Request(
    `${config.apiGateway.URL}/clinics/trigger/choices/`,
    {
      method: "GET",
      headers: myHeaders,
    }
  );
  const response = await fetch(req);
  const json = await response.json();
  const res = {
    json: json,
    status: response.status,
    message: response.message,
  };

  return res;
};

const getActionTypes = async () => {
  const myHeaders = Object.assign({ "Content-Type": "application/json" }, authHeader());

  const req = new Request(
    `${config.apiGateway.URL}/clinics/action/choices/`,
    {
      method: "GET",
      headers: myHeaders,
    }
  );
  const response = await fetch(req);
  const json = await response.json();
  const res = {
    json: json,
    status: response.status,
    message: response.message,
  };

  return res;
};

/////////////// POSTS ///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

// for manual {name, office_id, type}
// for auto   {name, office_id, type, campaign:{campaign_name, start_date, end_date, template: false, branches: [office_id]}}
const createGroup = async (data) => {
  const myHeaders = Object.assign({ "Content-Type": "application/json" }, authHeader());
  const raw = JSON.stringify(data);
  const req = new Request(config.apiGateway.URL + "/clinics/staging-groups/", {
    body: raw,
    method: "POST",
    headers: myHeaders,
  });

  const response = await fetch(req);
  var json = await response.json();
  statusHandeling.statusCodeHandeling(response.status);
  json.status = response.status;
  return json;
};

//body: { "patient_ids": [255187,255186],  "source_group_id": 0 }
const addPatients = async (groupId, data) => {
  const myHeaders = Object.assign({ "Content-Type": "application/json" }, authHeader());
  const raw = JSON.stringify(data);
  const req = new Request(`${config.apiGateway.URL}/clinics/staging-groups/${groupId}/add-patient/`, {
    body: raw,
    method: "POST",
    headers: myHeaders,
  });

  const response = await fetch(req);
  var json = await response.json();
  statusHandeling.statusCodeHandeling(response.status);
  json.status = response.status;
  return json;
};

// payload: selectorsIds =  {campaign: {id: 1, audience_selectors: [1,2]} }
const addAudiencSelectorsToBoard = async (boardId, selectorsIds) => {
  const myHeaders = Object.assign({ "Content-Type": "application/json" }, authHeader());

  const req = new Request(`${config.apiGateway.URL}/clinics/staging-groups/${boardId}/`, {
    method: "PATCH",
    headers: myHeaders,
    body: JSON.stringify(selectorsIds),
  });

  const response = await fetch(req);
  const json = await response.json();

  if (response.status > 250) {
    const res = { json, status: response.status, message: response.message };
    return res;
  }

  const res = { json, status: 204, message: "Board updated successfully", };
  statusHandeling.statusCodeHandeling(res.status);
  return res;
};

// payload: action
const editAction = async (actionId, data) => {
  const myHeaders = Object.assign({ "Content-Type": "application/json" }, authHeader());

  const req = new Request(`${config.apiGateway.URL}/clinics/campaign-action/${actionId}/`, {
    method: "PATCH",
    headers: myHeaders,
    body: JSON.stringify(data),
  });

  const response = await fetch(req);
  const json = await response.json();

  if (response.status > 250) {
    const res = { json, status: response.status, message: response.message };
    return res;
  }

  const res = { json, status: 204, message: "Action updated successfully", };
  statusHandeling.statusCodeHandeling(res.status);
  return res;
};

//body:  {name, service: "brevo"/isSms:"Twilio", subject(just for email), text, bulk: false, template: false,}
const sendEmailTemplate = async (data, isSms) => {
  const myHeaders = Object.assign({ "Content-Type": "application/json" }, authHeader());
  const raw = JSON.stringify(data);
  const req = new Request(`${config.apiGateway.URL}/clinics/campaign-${isSms ? 'sms' : 'email'}-templates/`, {
    body: raw,
    method: "POST",
    headers: myHeaders,
  });

  const response = await fetch(req);
  var json = await response.json();
  statusHandeling.statusCodeHandeling(response.status);
  json.status = response.status;
  return json;
};



const editEmailTemplate = async (templateId, data, isSms) => {
  const myHeaders = Object.assign({ "Content-Type": "application/json" }, authHeader());
  const raw = JSON.stringify(data);
  const req = new Request(
    `${config.apiGateway.URL}/clinics/campaign-${isSms ? 'sms' : 'email'}-templates/${templateId}/`,
    {
      method: "PATCH",
      headers: myHeaders,
      body: raw,
    }
  );
  const response = await fetch(req);
  const json = await response.json();
  const res = {
    json: json,
    status: response.status,
    message: response.message,
  };
  return res;
}


/////////////// DELETES ///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

const removePatient = async (groupId, patientId) => {
  const myHeaders = Object.assign({ "Content-Type": "application/json" }, authHeader());

  const req = new Request(`${config.apiGateway.URL}/clinics/staging-groups/${groupId}/remove-patient/${patientId}/`, {
    method: "DELETE",
    headers: myHeaders,
  });

  const response = await fetch(req);

  if (response.status > 250) {
    const json = await response.json();
    const res = {
      json: json,
      status: response.status,
      message: response.message,
    };
    statusHandeling.statusCodeHandeling(res.status);
    return res;
  }

  const res = {
    json: { message: "succssfull" },
    status: 204,
    message: "Service deleted successfully",
  };
  statusHandeling.statusCodeHandeling(res.status);
  return res;
};

const removeGroup = async (groupId) => {
  const myHeaders = Object.assign({ "Content-Type": "application/json" }, authHeader());

  const req = new Request(`${config.apiGateway.URL}/clinics/staging-groups/${groupId}/`, {
    method: "DELETE",
    headers: myHeaders,
  });

  const response = await fetch(req);

  if (response.status > 250) {
    const json = await response.json();
    const res = {
      json: json,
      status: response.status,
      message: response.message,
    };
    statusHandeling.statusCodeHandeling(res.status);
    return res;
  }

  const res = {
    json: { message: "succssfull" },
    status: 204,
    message: "Service deleted successfully",
  };
  statusHandeling.statusCodeHandeling(res.status);
  return res;
};

const removeAction = async (actionId) => {
  const myHeaders = Object.assign({ "Content-Type": "application/json" }, authHeader());

  const req = new Request(`${config.apiGateway.URL}/clinics/campaign-action/${actionId}/`, {
    method: "DELETE",
    headers: myHeaders,
  });

  const response = await fetch(req);

  if (response.status > 250) {
    const json = await response.json();
    const res = {
      json: json,
      status: response.status,
      message: response.message,
    };
    statusHandeling.statusCodeHandeling(res.status);
    return res;
  }

  const res = {
    json: { message: "succssfull" },
    status: 204,
    message: "Action deleted successfully",
  };
  statusHandeling.statusCodeHandeling(res.status);
  return res;
};

const createAudience = async (audienceData) => {
  const myHeaders = Object.assign({ "Content-Type": "application/json" }, authHeader());

  const req = new Request(`${config.apiGateway.URL}/clinics/audience-selectors/create/`, {
    method: "POST",
    headers: myHeaders,
    body: JSON.stringify(audienceData),
  });

  const response = await fetch(req);

  if (response.status > 250) {
    const json = await response.json();
    const res = { json, status: response.status, message: response.message };
    return res;
  }

  const res = {
    json: { message: "succssfull" },
    status: 204,
    message: "Service deleted successfully",
  };
  statusHandeling.statusCodeHandeling(res.status);
  return res;
};

export const controller = {
  getAllBoards,
  manualBoardSearchPatient,
  autoBoardSearchPatient,
  getProcessingPatients,
  getPatientsByOffice,
  getPatientDetails,
  createGroup,
  addPatients,
  removePatient,
  removeGroup,

  // Audience
  createAudience,
  getBoardDetails,
  getAudienceSelectorsByOfficeId,
  addAudiencSelectorsToBoard,
  //Action
  getActionTriggerOptions,
  getActionTypes,
  sendEmailTemplate,
  getEmailTemplates,
  editEmailTemplate,
  removeAction,
  editAction,
};
